import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { PAGE_ROUTES } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/routingConstants'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { getHasFetchedUser } from '../data/login/loginSelector'

export const useComingSoonRedirect = () => {
  const hasFetchedUser = useSelector(getHasFetchedUser)
  const { shouldRedirectToComingSoon } = useFlags()

  useEffect(() => {
    // Only redirect if user data has been fetched and the feature flag is enabled
    if (hasFetchedUser && shouldRedirectToComingSoon) {
      // Check if we're not already on the coming soon page to avoid infinite redirects
      if (window.location.pathname !== PAGE_ROUTES.COMING_SOON_MICROSITE) {
        window.location.replace(PAGE_ROUTES.COMING_SOON_MICROSITE)
      }
    }
  }, [hasFetchedUser, shouldRedirectToComingSoon])
}
